import type { Route } from 'vue-router'
import type { AppRouteConfig } from '../../models'
import { FeatureIdEnum } from '../../enums'
import RelatedPromptsLanding from '../../views/related-prompts/related-prompts-landing.view.vue'
import RelatedPromptsOverview from '../../views/related-prompts/related-prompts-overview.view.vue'
import RelatedPromptsPreview from '../../views/related-prompts/related-prompts-preview.view.vue'
import { ROUTER_CONSTS } from '../router.consts'
import { ROUTES_PATHS } from '../routes.paths'

const RELATED_PROMPTS_PATHS = Object.assign(ROUTES_PATHS, {
  relatedPrompts: 'relatedPrompts',
})

export const RELATED_PROMPTS_ROUTES: Array<AppRouteConfig> = [
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.RELATED_PROMPTS].landing,
    path: RELATED_PROMPTS_PATHS.relatedPrompts,
    component: RelatedPromptsLanding,
    meta: {
      featureId: FeatureIdEnum.RELATED_PROMPTS,
    },
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.RELATED_PROMPTS].preview,
    path: `${RELATED_PROMPTS_PATHS.relatedPrompts}/preview`,
    component: RelatedPromptsPreview,
    meta: {
      featureId: FeatureIdEnum.RELATED_PROMPTS,
      titleI18nKey: 'preview',
      parentRouteName: ROUTER_CONSTS.routes[FeatureIdEnum.RELATED_PROMPTS].landing,
    },
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.RELATED_PROMPTS].overview,
    path: `${RELATED_PROMPTS_PATHS.relatedPrompts}/overview`,
    component: RelatedPromptsOverview,
    meta: {
      featureId: FeatureIdEnum.RELATED_PROMPTS,
      titleI18nKey: 'overview',
      parentRouteName: ROUTER_CONSTS.routes[FeatureIdEnum.RELATED_PROMPTS].preview,
    },
  },
]

export function isRelatedPromptsRoute(route: Route): boolean {
  return (
    !!route.name &&
    Object.values(RELATED_PROMPTS_ROUTES)
      .map(routeConfig => routeConfig.name)
      .includes(route.name)
  )
}
